import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, setImgsize, loadScript } from "@/utils/utils";
import mapassembly from '@/view/map/custom/mapassembly';
export default {
  name: 'kunshan1',
  meta: {
    title: '昆山'
  },
  components: {
    mapassembly
  },
  data() {
    return {
      fid: this.$route.query.fid,
      formUserId: this.$route.query.formUserId,
      mapconfigform: {
        formId: '177623',
        pageSize: 1
      },
      mapdataform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      mapcfData: '',
      map: null,
      mapconfig: {
        mapMinZoom: 10,
        mapMaxZoom: 13,
        center: [],
        extent: [],
        currentZoom: 10
      },
      mapconfigdatas: {},
      // 地图管理配置对象
      isApp: false,
      page: 1,
      pauseTime: 5,
      // 无操作停留时间
      countDown: null,
      query: '',
      searchKey: '',
      listFlag: false,
      dataList: [],
      descFlag: false,
      dataListCopy: [],
      nodataFlag: false,
      linkdata: {},
      isItemClick: false,
      typeList: [],
      typeImg: [{
        url: require('@/assets/map/254023/nav1.png'),
        urlOn: require('@/assets/map/254023/nav1on.png')
      }, {
        url: require('@/assets/map/254023/nav2.png'),
        urlOn: require('@/assets/map/254023/nav2on.png')
      }, {
        url: require('@/assets/map/254023/nav3.png'),
        urlOn: require('@/assets/map/254023/nav3on.png')
      }, {
        url: require('@/assets/map/254023/nav4.png'),
        urlOn: require('@/assets/map/254023/nav4on.png')
      }],
      pickeyImg: [require('@/assets/map/254023/pickey1.png'), require('@/assets/map/254023/pickey2.png'), require('@/assets/map/254023/pickey1.png'), require('@/assets/map/254023/pickey3.png')],
      cTypeIndex: 0,
      zindex: 11
    };
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    if (document.body.clientWidth < 926) this.isApp = true;
    this.query = this.$route.query;
    this.getmapconfigform();
  },
  watch: {},
  methods: {
    // 获取地图配置数据 方便多个地图配置
    getmapconfigform() {
      let that = this;
      this.mapconfigform.deptId = this.fid;
      this.$api.singleformUserId(this.fid, this.mapconfigform.formId, this.formUserId).then(res => {
        // console.log(res)
        that.currentformuser = res.formUserList[0];
        that.mapcfData = res.formUserList[0].formData;
        if (res.formUserList.length > 0) {
          that.mapcfData.forEach(item => {
            that.mapconfigdatas[transformStr3(item.alias)] = that.getformitemsdata(item);
          });
          that.linkdata.img = that.mapconfigdatas[50];
          that.linkdata.link = that.mapconfigdatas[51];
          that.mapconfigdatas.pickey = this.pickeyImg[0];
          console.log(that.mapconfigdatas);
        }
      });
    },
    getformitemsdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (data.compt === 'imagebox') typekey = 'fileUrl';
      return data.values.length && data.values[0] ? data.values[0][typekey] : '';
    },
    /*
    ** 获取地图点数据 2024/01/24
    */
    getmapdataform() {
      let that = this;
      this.mapdataform.deptId = this.fid;
      this.$api.singleadvanceSearch(this.mapdataform).then(res => {
        if (that.mapdataform.page === 1) that.nodataFlag = res.dataList.length > 0 ? false : true;
        if (res.dataList.length > 0) {
          that.dataformat(res);
          if (res.totalPage > 1) {
            that.mapdataform.page++;
            if (res.totalPage >= that.mapdataform.page) that.getmapdataform();
          }
        }
      }).catch(e => {
        console.log(e);
      });
    },
    dataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        item.itemformdata.address = itemformat.route.length > 0 && itemformat.route[0].address ? itemformat.route[0].address : '';
        item.itemformdata.image = setImgsize(itemformat[4][0], 160, 104);
      });
      if (this.mapdataform.page === 1) {
        this.dataList = res.dataList.filter(item => {
          return item.itemformdata['42'] !== '仅展示';
        });
      } else {
        this.dataList.concat(res.dataList.filter(item => {
          return item.itemformdata['42'] !== '仅展示';
        }));
      }
      // 不可移总地图 列表 去掉当前地点数据
      if (this.formUserId === '842035648') {
        this.dataList = this.dataList.filter(item => {
          return item.itemformdata.title !== '00008';
        });
      }
      this.dataListCopy = this.dataList;
    },
    /*
    ** 关闭弹窗 2024/01/24
    */
    closeHandle() {},
    /*
    ** 返回不可移首页
    */
    goLink(val) {
      window.open(val);
    },
    /*
    ** 返回首页
    */
    goHome(val) {
      window.open(location.protocol + '//' + location.host + location.pathname + '#/tgx?formId=1135698&fid=113693&formUserId=842035648');
    },
    typeListHandle(val) {
      this.typeList = val;
    },
    typeLiClick(item, index) {
      this.cTypeIndex = index;
      let data = {
        index: index,
        item: item
      };
      data.typemodel = {
        flag: true,
        model: 6
      };
      this.mapconfigdatas.pickey = this.pickeyImg[index];
      this.$refs.map.typeselect(data);
    },
    detailHandle(val) {
      console.log(val);
    }
  }
};